import { defineMessages } from "react-intl";

const messages = defineMessages({
    modify: {
        id: "general.modify",
    },
    rotate: {
        id: "cropper.rotate",
    },
});

export default messages;
